let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2OZ9I")).then(() => parcelRequire('9bC8s'));